import { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link} from 'react-router-dom';
import { useAuth } from '../utils/AuthContext';
import { getClosedOrders } from '../api/commerce';
import { useParams } from "react-router-dom";
import { Info } from 'lucide-react';
import { SidebarProvider } from "../components/SidebarContext";
import InfoMark from '../components/InfoMark';
import ContactFormModal from '../components/ContactFormModal';
import Loading from '../components/loading/Loading';
import NavbarLog from '../components/NavbarLog';
import Footer from '../components/Footer';
import SidebarToggle from '../components/SidebarToggle';
import Sidebar from '../components/Sidebar';
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import jalaliday from "jalaliday";
import "dayjs/locale/fa";
import "../css/OrderMgmt.css";

const OrderReview = () => {
  const [orders, setOrders] = useState([]);
  const [itemSeller, setItemSeller] = useState("");
  const [itemId, setItemId] = useState("");
  const [isContModalOpen, setIsContModalOpen] = useState(false);
  const [isInfoModal, setInfoModal] = useState(false);
  const [InfoP, setInfoP] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [error, setError] = useState(null);
  const [consoleError, setConsoleError] = useState("");
  const [activeTab, setActiveTab] = useState("open"); 
  const [setlang, setLang] = useState("fa")
  const { lang } = useParams();
  const { user, isAuthenticated, loading} = useAuth();
  const navigate = useNavigate();
  const location = useLocation();


  useEffect(() => {
    if (!loading) {
      if (!user) {
        navigate(`/${lang}/login`, { state: { from: location }, replace: true });
      }
    }
  }, [user, isAuthenticated, loading, navigate, location]);
  
  useEffect(() => {
    fetch("/data/InfoNote.json")
      .then((res) => res.json())
      .then((data) => setInfoP(data.OrderManagement))
      .catch((err) => setConsoleError("Error loading content:", err));
  }, []);
  
  const fetchOrders = async () => {
    try {
      const res = await getClosedOrders();
      setOrders(res.data.results);
    } catch (error) {
      setConsoleError("Error loading user information:", error);
    } 
  };

  useEffect(() => {
    fetchOrders();
  }, []);
  

  // Utilities
  const handleContact = (seller, prod) => {
    setItemSeller(seller);
    setItemId(prod);
    setIsContModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsContModalOpen(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  // Transation
  dayjs.extend(utc);
  dayjs.extend(jalaliday);
  const toPersiDigits = (str) => 
    str
    .replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d])
    .replace(/\./g, '/');

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])



  if (loading) return <Loading />;  
  if (!isAuthenticated) return <p>{setlang==="en"?"You must be logged in to review orders.":"لطفا ابتدا وارد حساب کاربری شو"}</p>;
  
  return (
    <>
      <NavbarLog />
      <SidebarProvider>
      <SidebarToggle />

      <Info size={25} className={setlang==="en"?"InfoMark-en":"InfoMark-fa"} onMouseEnter={()=>setInfoModal(true)} onMouseLeave={()=>setInfoModal(false)}/>
      {isInfoModal && <InfoMark info={setlang==="en"?InfoP.en:InfoP.fa} setlang={setlang}/>}

      <div className={setlang==="en"?"order-page-en":"order-page-fa"}>
        
        {setlang==="en" && 
        <Sidebar />
        }

        {setlang === "en" ?
        <div className='order-list'>
          <h2>My Orders</h2>
          <div className="order-tabs-container">
            <Link to={`/${setlang}/review/open-orders`}>
              <button
                onClick={() => setActiveTab("open")}
                >
                {setlang === "en" ? "Open" : "در حال ارسال"}
              </button>
            </Link>
            <Link to={`/${setlang}/review/canceled-orders`}>
              <button
                onClick={() => setActiveTab("canceled")}
                >
                {setlang === "en" ? "Canceled" : "لغو شده"}
              </button>
            </Link>
            <Link to={`/${setlang}/review/closed-orders`}>
              <button
                onClick={() => setActiveTab("past")}
                className={"active"}
                >
                {setlang === "en" ? "Past" : "بسته شده"}
              </button>
            </Link>
          </div>
          {orders.length === 0 ? (
            <p style={{margin:"1rem"}}>No closed orders yet.</p>
          ) : (
            orders.map((order) => (
              <>
                <div key={order.id} className='item-list'>
                  <ul>
                    {order.items.map((item) => (
                      <li key={item.id}>
                        <div className="order-images">
                          {Array.isArray(item.product_images) && item.product_images.length > 0 &&
                            item.product_images.map((img) => (
                              <img
                                key={img.id}
                                src={img.image}
                                alt={item.product_name}
                                className="order-image"
                              />
                            ))
                          }
                          {/* Videos */}
                          {Array.isArray(item.product_videos) && item.product_videos.length > 0 &&
                            item.product_videos.map((vid) => (
                              <video
                                key={vid.id} 
                                src={vid.video}
                                controls
                                className="order-image"
                              />
                            ))
                          }
                        </div>  
                        <div className="arrival-note">
                          <div>
                            <p><strong>{item.product_name}</strong></p>
                            <p>Price: IRT {new Number(item.price).toLocaleString()}</p>
                            <p>Seller: {item.seller_username}</p>
                            <p>Shipped by: {item.shipping_style}</p>
                            <p>
                              <strong>Note:</strong> deliveries may take <span className="highlight">up to two weeks</span>.
                            </p>
                            <span><strong>Arrives latest by: </strong>{dayjs.utc(item.arrival_date).calendar("jalali").locale("fa").format("YYYY/MM/DD")}</span>
                          </div>
                            <div className='cont-contact-button'>
                              <button onClick={()=>handleContact(item.seller, item.product)}>{setlang === "en" ? "Contact Seller" : "تماس با فروشنده" }</button>
                            </div>

                            {isContModalOpen && (
                            <div onClick={handleOverlayClick} className="modal-overlay" type='submit'> 
                              <div className="c-modal-container" onClick={e => e.stopPropagation()}>
                                <ContactFormModal receiverId={itemSeller} itemId={itemId} setlang={setlang}/>
                              </div>
                            </div>
                            )}                        
                          </div>
                      </li>
                    ))}
                  </ul>
                  <div className="order-sum">
                    <p>Total: IRT{new Number(order.total_amount).toLocaleString()}</p>
                    {order.order_status==="paid"?(
                      <p>Order Status: will be shipped soon</p>
                    ):(
                      <p>Order Status: {order.order_status}</p>
                    )}
                    <p>Order Number: {order.order_number}</p>
                    <p>Placed on: {dayjs.utc(order.created_at).calendar("jalali").locale("fa").format("YYYY/MM/DD")}</p>
                  </div>

                  <div className='delivery-info'>
                    <h3>Delivery information</h3>
                    <p>Tracking Number: {order.delivery.tracking_number}</p>
                    <p>Delivery Status: {order.delivery.status}</p>
                    <p>Receiver: {order.delivery.last_name}, {order.delivery.first_name} </p>
                    <p>E-mail: {order.delivery.email} Phone No.:{order.delivery.contact} </p>
                    <p>Address: {order.delivery.address} </p>
                    <p>{order.delivery.city}, {order.delivery.province}, {order.delivery.country} </p>
                    <p>Zipcode:{order.delivery.zipcode}</p>
                  </div>
                </div>
              </>
            ))
          )}
        </div> 
        :
        <div className='order-list'>
          <h2>سفارش‌های من</h2>

          <div className="order-tabs-container-fa">
            <Link to={`/${setlang}/review/open-orders`}>
              <button
                onClick={() => setActiveTab("open")}
                >
                {setlang === "en" ? "Open" : "در حال ارسال"}
              </button>
            </Link>
            <Link to={`/${setlang}/review/canceled-orders`}>
              <button
                onClick={() => setActiveTab("canceled")}
                >
                {setlang === "en" ? "Canceled" : "لغو شده"}
              </button>
            </Link>
            <Link to={`/${setlang}/review/closed-orders`}>
              <button
                onClick={() => setActiveTab("past")}
                className={"active"}
                >
                {setlang === "en" ? "Past" : "بسته شده"}
              </button>
            </Link>
          </div>

          {orders.length === 0 ? (
            <p style={{margin:'20px'}}>شما تا اکنون سفارش بسته‌ شده‌ای ندارید</p>
          ) : (
            orders.map((order) => (
              <>
                <div key={order.id} className='item-list'>
                  <ul>
                    {order.items.map((item) => (
                      <li key={item.id}>
                        <div className="order-images">
                          {Array.isArray(item.product_images) && item.product_images.length > 0 &&
                            item.product_images.map((img) => (
                              <img
                                key={img.id}
                                src={img.image}
                                alt={item.product_name}
                                className="order-image"
                              />
                            ))
                          }
                          {/* Videos */}
                          {Array.isArray(item.product_videos) && item.product_videos.length > 0 &&
                            item.product_videos.map((vid) => (
                              <video
                                key={vid.id} 
                                src={vid.video}
                                controls
                                className="order-image"
                              />
                            ))
                          }
                        </div>  
                        
                        <div className="arrival-note-fa">
                          <div>
                            <p><strong>{item.product_name}</strong></p>
                            <p>قیمت(تومان): {toPersiDigits(new Number(item.price).toLocaleString())}</p>
                            <p>فروشنده: {item.seller_username}</p>
                            <p>ارسال از راه: {item.shipping_style}</p>
                            <p>
                              <strong>توجه: </strong>سفارش‌های ارسالی ممکن است تا<span className="highlight"> ۱۲ روز کاری </span> به طول انجامد
                            </p>
                            <span><strong>دریافت تا تاریخ: </strong>{toPersiDigits(dayjs.utc(item.arrival_date).calendar("jalali").locale("fa").format("YYYY/MM/DD"))}</span>
                            <div className='cont-contact-button'>
                              <button onClick={()=>handleContact(item.seller, item.product)}>{setlang === "en" ? "Contact Seller" : "تماس با فروشنده" }</button>
                            </div>

                            {isContModalOpen && (
                            <div onClick={handleOverlayClick} className="modal-overlay" type='submit'> 
                              <div className="c-modal-container" onClick={e => e.stopPropagation()}>
                                <ContactFormModal receiverId={itemSeller} itemId={itemId} setlang={setlang}/>
                              </div>
                            </div>
                            )}
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                  <div className="order-sum-fa">
                    <p><strong>جمع کل(تومان): </strong>{toPersiDigits(new Number(order.total_amount).toLocaleString())}</p>
                    {order.order_status==="paid"?(
                      <p><strong>وضعیت سفارش: </strong>به زودی ارسال خواهد شد </p>
                    ):(
                      <p>وضعیت: {order.order_status}</p>
                    )}
                    <p>شماره سفارش: {order.order_number}</p>
                    <p>تاریخ سفارش: {toPersiDigits(dayjs.utc(order.created_at).calendar("jalali").locale("fa").format("YYYY/MM/DD"))}</p>
                  </div>

                  <div className='delivery-info-fa'>
                    <h3>آدرس پستی</h3>
                    <p>شماره رهگیری پست: {order.delivery.tracking_number} </p>
                    <p>وضعیت سفارش: {order.delivery.status}</p>
                    <p>گیرنده: {order.delivery.first_name}, {order.delivery.last_name}</p>
                    <p>ایمیل: {order.delivery.email}</p>
                    <p>موبایل: {order.delivery.contact}</p>
                    <p>{order.delivery.address} </p>
                    <p>{order.delivery.city}, {order.delivery.province}, {order.delivery.country} </p>
                    <p>کد پستی: {order.delivery.zipcode}</p>
                  </div>
                </div>
              </>
            ))
          )}
        </div>
        }
        
        {setlang==="fa" && 
          <Sidebar />
        }

      </div>
      </SidebarProvider>
      <Footer />
    </>
  );
};

export default OrderReview;
